var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 5.37067 18.6293 0 12 0C5.37067 0 0 5.37067 0 12C0 17.9893 4.38933 22.9547 10.1227 23.856V15.4667H7.072V12H10.1227V9.35467C10.1227 6.34667 11.9147 4.688 14.656 4.688C15.968 4.688 17.344 4.92267 17.344 4.92267V7.872H15.8293C14.3413 7.872 13.872 8.79467 13.872 9.744V11.9947H17.2L16.6667 15.4613H13.872V23.8453C19.6107 22.9493 24 17.9893 24 12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.556d8c69f761375907de3acad11bb68f.svg";
export { ForwardRef as ReactComponent };